import { useFormContext } from 'react-hook-form';
import { useMemo } from 'react';

export const useOptimizedFormWatch = () => {
  const form = useFormContext();

  // Extract watched values to avoid complex expressions in dependency array
  const variantMode = form.watch('variant_mode');
  const productType = form.watch('product_type');
  const isDigitalDownload = form.watch('is_digital_download');
  const requiresActivationKey = form.watch('requires_activation_key');
  const trackDigitalStock = form.watch('track_digital_stock');
  const trackInventory = form.watch('track_inventory');
  const requiresShippingAddress = form.watch('requires_shipping_address');
  const requiresConsultation = form.watch('requires_consultation');
  const isCustomizable = form.watch('is_customizable');
  const isServiceAvailable = form.watch('is_service_available');

  return useMemo(() => {
    const watchedValues = {
      variantMode: variantMode || 'single',
      productType: productType,
      isDigitalDownload: isDigitalDownload || false,
      requiresActivationKey: requiresActivationKey || false,
      trackDigitalStock: trackDigitalStock || false,
      trackInventory: trackInventory || false,
      requiresShippingAddress: requiresShippingAddress || false,
      requiresConsultation: requiresConsultation || false,
      isCustomizable: isCustomizable || false,
      isServiceAvailable: isServiceAvailable ?? true,
    };

    return watchedValues;
  }, [
    variantMode,
    productType,
    isDigitalDownload,
    requiresActivationKey,
    trackDigitalStock,
    trackInventory,
    requiresShippingAddress,
    requiresConsultation,
    isCustomizable,
    isServiceAvailable,
  ]);
};

export default useOptimizedFormWatch;
